import { Form } from '@tribeplatform/react-sdk/components'
import { useNetwork, useUpdateNetwork } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import { LogoPicker } from './LogoPicker'
import { SquareLogoPicker } from './SquareLogoPicker'

export const GeneralSettings = () => {
  const { data: network } = useNetwork()
  const { mutateAsync: updateNetwork, isLoading } = useUpdateNetwork()

  return (
    <Card>
      <Card.Header title="General settings" />
      <Card.Content className="flex flex-col space-y-5">
        <div className="flex space-x-5">
          <LogoPicker />
          <SquareLogoPicker />
        </div>
        <Form
          defaultValues={network}
          onSubmit={async data => {
            const { name, termsOfServiceUrl, privacyPolicyUrl } = data

            return updateNetwork({
              input: {
                name,
                termsOfServiceUrl,
                privacyPolicyUrl,
              },
            })
          }}
        >
          <div className="col-span-12 md:col-span-8 flex flex-col space-y-5">
            <Form.Input
              name="name"
              label="Community name"
              placeholder="Acme Community"
            />
            <Form.Input name="termsOfServiceUrl" label="Terms of service" />
            <Form.Input name="privacyPolicyUrl" label="Privacy policy" />
            <Form.Actions>
              <Button type="submit" loading={isLoading}>
                Update
              </Button>
            </Form.Actions>
          </div>
        </Form>
      </Card.Content>
    </Card>
  )
}
